import {
  Autocomplete,
  Avatar,
  Box,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import { FC, Fragment, useState } from "react";
import { PdfData } from "@/models/pdfData";
import { millisToTime } from "@/services/dateTimeService";
import { useResponsiveContext } from "@context/ResponsiveContext";
import GameSelectionLine from "@components/controls/GameSelectionLine";

export interface GameSelectionDropdownOption extends PdfData {
  prettyDate: string;
}

const GameSelectionDropdown: FC<{
  loadingGames: boolean;
  games: GameSelectionDropdownOption[];
  onGameSelected: (samsId: string) => void;
  samsIdError?: boolean;
}> = ({ loadingGames, games, onGameSelected, samsIdError }) => {
  const [autocompleteOpen, setAutocompleteOpen] = useState(false);

  const handleAutocompleteOpen = () => {
    setAutocompleteOpen(true);
  };

  const handleAutocompleteClose = () => {
    setAutocompleteOpen(false);
  };

  return (
    <Autocomplete
      id="samsId"
      //error={samsIdError}
      disabled={loadingGames}
      open={autocompleteOpen}
      groupBy={(option) => option.prettyDate.substring(0, 8)}
      onOpen={handleAutocompleteOpen}
      onClose={handleAutocompleteClose}
      onChange={(event, newValue) =>
        newValue && onGameSelected(newValue.samsId)
      }
      filterOptions={(options, state) => {
        return options.filter((o) =>
          [
            o.samsId,
            o.gameData.location,
            o.gameData.gameNumber,
            o.gameData.team1.longName,
            o.gameData.team1.shortName,
            o.gameData.team2.longName,
            o.gameData.team2.shortName,
            o.prettyDate,
          ].some(
            (v) =>
              v && v.toLowerCase().includes(state.inputValue.toLowerCase()),
          ),
        );
      }}
      isOptionEqualToValue={(option, value) => option.samsId === value.samsId}
      options={games}
      loading={loadingGames}
      renderOption={(props, option) => (
        <GameSelectionLine
          props={props}
          option={option}
          showImagesOnDesktop={games.length < 200}
        />
      )}
      getOptionLabel={(option) => option.samsId}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus
          required
          margin="dense"
          id="samsId"
          type="text"
          fullWidth
          label="Spiel auswählen"
          error={samsIdError}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {loadingGames ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </Fragment>
              ),
            },
          }}
        />
      )}
    />
  );
};

export default GameSelectionDropdown;
